import { getTenantDomain } from "./index";
import BrokenImage from "../assets/images/Broke-img.jpg";

// The mosaic shows the first photo large and at most four more beside it.
export const MOSAIC_MAX_TILES = 5;

// Photos of a property: a thumbnail for small tiles and the original for the
// large tile and the viewer. Without photos the featured image or a
// placeholder keeps the gallery from collapsing.
export const galleryPhotos = (images = [], tenant, featuredImage = null) => {
  const assets = `${getTenantDomain(tenant)}/tenancy/assets/`;
  const photos = images
    .filter((image) => image?.filename)
    .map((image) => {
      const thumb = `${assets}properties/gallery/thumbnails/${image.filename}`;

      return {
        thumb,
        full: image.original_file_path
          ? `${assets}${image.original_file_path}`
          : thumb,
      };
    });

  if (photos.length > 0) return photos;
  if (featuredImage) {
    const featured = `${assets}${featuredImage}`;

    return [{ thumb: featured, full: featured }];
  }

  return [{ thumb: BrokenImage, full: BrokenImage, placeholder: true }];
};

export const mosaicTileCount = (count) => Math.min(Math.max(count, 0), MOSAIC_MAX_TILES);
